/* eslint-disable react/no-unstable-nested-components */
import React, { memo, useEffect, useState } from 'react';
import { Image, Icon, Popup, Label, Menu } from 'semantic-ui-react';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import IconLogout from 'Assets/images/logout.png';
import IconQRCode from 'Assets/images/commons/qrcode.svg';
import IconInfo from 'Assets/icons/icon-info.svg';
import { logout } from 'Redux/modules/auth/actions';
import { Divider, Select } from 'antd';
import { useCurrentClinic } from 'Containers/Home/hooks/useCurrentClinic';
import useClinic from 'Containers/Home/hooks/useClinic';
import useAuth from 'Hooks/useAuth';
import Text from 'Components/Text';
import { getBadges, seenAllNotifications } from 'Redux/modules/notification/actions';

import MaNaDrLogo from '../../../../assets/images/header-logo.png';
import MaNaDrLogoCollapse from '../../../../assets/images/logo-3.png';
import routes from '../../../routes/main';
import useUI from '../hooks/useUI';
import NotificationList from '../../../containers/Notification/List/NotificationList';
import DoctorQRCode from '../Sidebar/DoctorQRCode/DoctorQRCode';
import ModalSPA from '../Sidebar/ModalSPA/ModalSPA';

import style from './Header.less';

// const activeColor = '#4a90e2';
// const nullColor = '#333';

const Header = () => {
  const { toggleSidebar } = useUI();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [showQrCode, setShowQrCode] = useState(false);
  const [showSPA, setShowSPA] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const { badges } = useSelector(state => state.notification);
  const { isSidebarCollapsed } = useSelector(state => state.ui);
  const { profile } = useSelector(state => state.doctors);
  const { refreshToken } = useSelector(state => state.auth.data);

  const { accountId } = useAuth();
  const location = useLocation();
  const { currentClinicId, saveCurrentClinic, clearCurrentClinic } = useCurrentClinic();
  const { clinics } = useClinic(accountId);

  const currentRouteName = routes.find(item => {
    const path = item.path.replace(':id', '');
    return (
      item.path === location.pathname ||
      (item.path.includes(':id') &&
        location.pathname.includes(path) &&
        location.pathname.replace(path))
    );
  });

  const showClinicSelect = false;

  const clinicOptions = (clinics || []).map(clinic => ({
    label: clinic.name,
    value: clinic.id,
  }));

  const handleShowQRCode = () => {
    setShowQrCode(true);
  };

  const handleCloseQRCode = () => {
    setShowQrCode(false);
  };

  const handleShowSPA = () => {
    setShowSPA(true);
  };

  const handleCloseSPA = () => {
    setShowSPA(false);
  };

  useEffect(() => {
    dispatch(getBadges());
  }, [dispatch]);

  // When click to notification icon -> seen all noti and clear badge
  useEffect(() => {
    if (open) {
      dispatch(seenAllNotifications());
    }
  }, [dispatch, open]);

  const renderProfile = () => {
    const { avatar, firstName, lastName, name } = profile || {};
    const userName = firstName ? `${firstName} ${lastName}` : name || '';
    return (
      <div className={style.headerProfile}>
        <img className={style.avatarImg} src={avatar?.previewPath} alt="avatar" />
        <div>{userName}</div>
        <div>
          <Icon name="angle down" />
        </div>
      </div>
    );
  };

  const handleLogout = () => {
    dispatch(logout(refreshToken));
    clearCurrentClinic();
  };

  return (
    <div className={style.headerContainer}>
      <div
        className={classnames([style.logoHeader], {
          [style.logoHeaderCollapse]: isSidebarCollapsed,
        })}>
        <Link to="/">
          <Image
            className={style.logo}
            src={isSidebarCollapsed ? MaNaDrLogoCollapse : MaNaDrLogo}
          />
        </Link>
      </div>
      <div className={style.header}>
        <div className={style.leftHeaderArea}>
          <div onClick={toggleSidebar} className={style.barsContainer}>
            <Icon name="bars" className={style.icon} />
          </div>
          <div className={style.leftHeaderTitle}>{currentRouteName?.name}</div>
          {showClinicSelect && (
            <Select
              options={clinicOptions}
              value={currentClinicId}
              onChange={saveCurrentClinic}
              style={{ width: 240 }}
              dropdownRender={menu => (
                <>
                  {menu}
                  <Divider style={{ margin: '8px 0' }} />
                  <div style={{ padding: '4px 12px 8px 12px' }}>
                    <Text type="secondary" style={{ fontSize: 12 }}>
                      Teleconsult taken will be tagged under selected clinic.
                    </Text>
                  </div>
                </>
              )}
            />
          )}
        </div>
        <div className={style.leftHeaderArea}>
          <div className={style.barsContainer}>
            <Popup
              trigger={
                <div style={{ cursor: 'pointer' }}>
                  <img alt="bell notification" src={require('Assets/images/commons/bell.svg')} />
                  {badges > 0 && (
                    <Label
                      style={{ top: '8px', right: '-6px', left: 'unset' }}
                      size="mini"
                      circular
                      color="red"
                      floating>
                      {badges}
                    </Label>
                  )}
                </div>
              }
              open={open}
              onOpen={() => setOpen(true)}
              onClose={e => {
                if (!e.target?.className?.includes('prevent-close-popup')) {
                  setOpen(false);
                }
              }}
              content={<NotificationList isPopup onClickItem={() => setOpen(false)} />}
              on="click"
              basic
              className={style.noPaddingPopup}
            />
          </div>
          <div>
            <Popup
              trigger={renderProfile()}
              open={openMenu}
              onOpen={() => setOpenMenu(true)}
              onClose={() => setOpenMenu(false)}
              position="bottom right"
              style={{ width: '250px' }}
              content={
                <Menu className={style.wrapMenu} pointing vertical>
                  <Menu.Item onClick={handleShowQRCode}>
                    <div className={style.qrCodeMenu}>
                      <img src={IconQRCode} alt="qrcode" />
                      <div>Show doctor QRcode</div>
                    </div>
                  </Menu.Item>
                  <Menu.Item onClick={handleShowSPA}>
                    <div className={style.qrCodeMenu}>
                      <img src={IconInfo} alt="SPA" />
                      <div>Service Provider Agreement</div>
                    </div>
                  </Menu.Item>
                  <Menu.Item onClick={handleLogout}>
                    <div className={style.logoutMenu}>
                      <img src={IconLogout} alt="icon logout" />
                      <div>Logout</div>
                    </div>
                  </Menu.Item>
                </Menu>
              }
              on="click"
              basic
              className={style.noPaddingPopup}
            />
          </div>
        </div>
      </div>
      {showQrCode && <DoctorQRCode userDetails={profile} onClose={handleCloseQRCode} />}
      {showSPA && <ModalSPA onClose={handleCloseSPA} />}
    </div>
  );
};

export default memo(Header);
